import './App.css';
import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import QuizPage from './pages/QuizPage';
import { LanguageProvider } from './context/LanguageContext';
import SourcesPage from './pages/SourcesPage';
import LandingPage from './pages/LandingPage';

const theme = createTheme({
    palette: {
        background: {
            default: "#FBFBFB",
        },
        text: {
            primary: "#010101",
        },
    },

    typography: {
        fontFamily: "Lato, sans-serif",

        h1: {
            fontFamily: "Bangers",
        },
        h2: {
            fontFamily: "Bangers",
        },
        h3: {
            fontFamily: "Bangers",
        },
        h4: {
            fontFamily: "Bangers",
        },
        h5: {
            fontFamily: "Bangers",
        },
        h6: {
            fontFamily: "Bangers",
        },
    },
});


const App: React.FC = () => {

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <LanguageProvider>
                <BrowserRouter>
                    <Routes>
                        <Route>
                            <Route path="/"
                                element={
                                    <LandingPage />
                                }
                            />
                            <Route path="/quiz"
                                element={
                                    <QuizPage />
                                }
                            />
                            <Route path="/sources"
                                element={
                                    <SourcesPage />
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;